import React, { useState } from "react";
import analytics from "web/script/analytics/analytics";
import classnames from "classnames";
import TrackedButton from "web/react/components/tracked-button/tracked-button";
import { gettext } from "web/script/modules/django-i18n";
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./brand-ad-container.css";

export interface BrandAdContainerProps {
    banner_image: string;
    link: string;
    mobile_link: string;
    mpu_image: string;
    product_image: string;
    product_link: string;
    product_description: string;
    partner: string;
    variant?: string;
}

function BrandAdContainer({
    banner_image: bannerImage,
    link,
    mobile_link: mobileLink,
    mpu_image: mpuImage,
    product_image: productImage,
    product_link: productLink,
    product_description: productDescription,
    partner,
    variant,
}: BrandAdContainerProps): null | JSX.Element {
    const [isActive, setIsActive] = useState(false);

    function toggleInfo(partner): void {
        analytics.event("brand_ads", "click", "perf_brand_ad_icon", false, { partner });
        setIsActive(!isActive);
    }

    return (
        <div
            className={classnames(styles.container, {
                [styles.pdpContainer]: variant,
            })}
        >
            <div className={styles.brandLogo}>
                <TrackedButton
                    className={styles.brandLogoLink}
                    href={productLink}
                    eventCategory="brand_ads"
                    eventAction="click"
                    eventLabel="perf_brand_product_image"
                    openInNewTab={true}
                    eventCustomData={{ partner }}
                >
                    <div className={styles.productDetailsContainer}>
                        <span
                            className={classnames(
                                styles.productDetails,
                                styles.productDetailsHeader
                            )}
                        >
                            {gettext("feed.header.featured_label")}
                        </span>
                        <span className={styles.productDetails}>{productDescription}</span>
                    </div>
                    <img
                        className={classnames(styles.containerImage, styles.brandLogoImage)}
                        src={productImage}
                        alt={productDescription}
                    />
                </TrackedButton>
            </div>
            <TrackedButton
                className={styles.bannerLink}
                href={link}
                eventCategory="brand_ads"
                eventAction="click"
                eventLabel="perf_brand_ad_banner"
                openInNewTab={true}
                eventCustomData={{ partner }}
            >
                <picture>
                    <source media="(min-width: 576px)" srcSet={bannerImage} />
                    <img className={styles.containerImage} src={bannerImage} alt="test banner" />
                </picture>
            </TrackedButton>
            <TrackedButton
                className={styles.bannerLinkSmall}
                href={mobileLink}
                eventCategory="brand_ads"
                eventAction="click"
                eventLabel="perf_brand_ad_banner"
                openInNewTab={true}
                eventCustomData={{ partner }}
            >
                <picture>
                    <source media="(max-width: 576px)" srcSet={mpuImage} />
                    <img className={styles.containerImage} src={mpuImage} alt="test banner" />
                </picture>
            </TrackedButton>
            <button
                className={classnames(styles.info, {
                    [styles.active]: isActive,
                })}
                onClick={toggleInfo}
            >
                <span className={styles.infoIcon}>{"i"}</span>
                <span className={styles.infoLabel}>{gettext("feed.header.sponsored_label")}</span>
            </button>
        </div>
    );
}

export default BrandAdContainer;
